module.exports = function() {
  return new Worker(__webpack_public_path__ + "cba4e4b008bfcf98fe90.worker.js");
};